import getVideoId from 'get-video-id'
import { dispatchCustomEvent } from './utils/browserUtils';

const ytPosterUrl = 'https://i.ytimg.com/vi_webp/<vid-id>/mqdefault.webp',
  divClass = 'gitb-dynamic-video ratio ratio-16x9',
  ytPlayBtnClass = 'gitb-yt-play-button';

//For each item with data-src=yout* video, place a poster/thumbnail of the video and onClick, load and play the video
export function dynamicYTVideo() {
  $('iframe[data-src*="yout"]').each((_, frame) => {
    let $frame = $(frame),
      { id } = getVideoId($frame.data('src')),
      title = $frame.data('title'),
      poster = $(`<div class="${divClass}">
            <img src="${ytPosterUrl.replace('<vid-id>', id)}" loading="lazy" alt="${title}" />
            <div class="${ytPlayBtnClass}"></div></div>`)
        .css({
          width: frame.width,
          height: frame.height,
          // background: `no-repeat center/100% url(${ytPosterUrl.replace('<vid-id>', id)})`
        }).on('click', function() {
          frame.src = `${$frame.data('src')}?autoplay=1`;
          $frame.data('src', null);
          $(this).replaceWith(frame).remove();
        });
    $frame.replaceWith(poster);
    setTimeout(() => {
      dispatchCustomEvent(poster[0], 'gitb-dynamic-video', { videoId: id })
    })
  });
}

// should only be run after all dynamic video functions have run
export function catchAllVideo() {
  $('iframe[data-src]').each((_, frame) => { frame.src = frame.dataset.src })
}

export default function () { // executes all dynamic video functions we may create
  dynamicYTVideo();
  catchAllVideo();
}
